import React, { Fragment, useState, useEffect, useRef } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import InboxIcon from "@mui/icons-material/Inbox";
import Drawer from "@mui/material/Drawer";
import { Link } from "react-router-dom";
import { duration, useTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import DeblurIcon from "@mui/icons-material/Deblur";
import IconButton from "@mui/material/IconButton";
import MailIcon from "@mui/icons-material/Mail";
import { useSelector, useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import SchoolIcon from "@mui/icons-material/School";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import ListItemButton from "@mui/material/ListItemButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import { themeStyle, themeStyleDark } from "./Components";
import HandshakeIcon from "@mui/icons-material/Handshake";
import SportsBasketballIcon from "@mui/icons-material/SportsBasketball";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import Select from "@mui/material/Select";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import AddTaskIcon from "@mui/icons-material/AddTask";
import ScrollTop from "./ScrollTop";
import Snackbar from "@mui/material/Snackbar";
import { Grid } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSpring, useSprings, useScroll, animated } from "@react-spring/web";
import { CardHorizontal, SpacerH, SpacerV } from "./Hero";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AppsIcon from "@mui/icons-material/Apps";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const drawerWidth = 310;

function Sidebar(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);

  const [open, setOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(0);
  const [scrollHidden, setScrollHidden] = useState(false);

  const [menuContainer, menuContainerApi] = useSpring(() => ({
    from: { opacity: 0 },
  }));

  const [menuContainer4, menuContainerApi4] = useSpring(() => ({
    from: { opacity: 0 },
  }));

  const [navContainer, navContainerApi] = useSpring(() => ({
    from: { transform: "translate(0px, -200px)", opacity: 0 },
    to: { transform: "translate(0px, 0px)", opacity: 1 },
    delay: props.delay,
    config: { duration: 400 },
  }));

  const menuUnderlines = useSprings(
    7,
    [0, 1, 2, 3, 4, 5, 6].map((prop, index) => ({
      from: { width: "0%" },
      to: { width: activeMenu == index ? "100%" : "0%" },
    }))
  );

  // const menuUnderlinesMouseEnter = () => {
  //   menuUnderlinesApi.start({
  //     from: { width: "0%" },
  //     to: { width: "100%" },
  //   });
  // };

  // const menuUnderlinesMouseLeave = () => {
  //   menuUnderlinesApi.start({
  //     from: { width: "100%" },
  //     to: { width: "0%" },
  //   });
  // };

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: drawerWidth,
    }),
  }));

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  }));

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      let direction = lastScrollY < window.scrollY ? "down" : "up";
      lastScrollY = window.scrollY;

      if (!scrollHidden) {
        if (window.scrollY > 500 && direction == "down") {
          navContainerApi.start({
            from: { transform: "translate(0px, 0px)", opacity: 0 },
            to: { transform: "translate(0px, -200px)", opacity: 1 },
            delay: props.delay,
            config: { duration: 400 },
          });
          setScrollHidden(true);
        }
      }
      if (scrollHidden) {
        if (window.scrollY > 500 && direction == "up") {
          navContainerApi.start({
            from: { transform: "translate(0px, -200px)", opacity: 0 },
            to: { transform: "translate(0px, 0px)", opacity: 1 },
            delay: props.delay,
            config: { duration: 400 },
          });
          setScrollHidden(false);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollHidden]);

  const flagDiv = (cc, cn) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          fontSize: "16px",
          cursor: "pointer",
          width: "200px",
        }}
      >
        <img
          style={{ marginRight: "15px" }}
          src={"https://flagsapi.com/" + cc + "/flat/64.png"}
        />
        <div style={{ color: "white" }}>{cn}</div>
      </div>
    );
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <ScrollTop />

      <Snackbar
        open={state.auth.alert != null ? true : false}
        autoHideDuration={6000}
        onClose={() => dispatch({ type: "REMOVE_ALERT" })}
        message={state.auth.alert == null ? "" : state.auth.alert.message}
        action={
          <div
            onClick={() => dispatch({ type: "REMOVE_ALERT" })}
            style={{ padding: "2px", cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        }
      />
      <div
        onMouseEnter={() => {
          if (scrollHidden) {
            navContainerApi.start({
              from: { transform: "translate(0px, -200px)", opacity: 0 },
              to: { transform: "translate(0px, 0px)", opacity: 1 },
              delay: props.delay,
              config: { duration: 400 },
            });
            setScrollHidden(false);
          }
        }}
        style={{
          height: "150px",
          width: "100vw",
          position: "fixed",
          zIndex: 1000,
        }}
      ></div>
      <AppBar
        position="fixed"
        open={open}
        elevation={0}
        sx={{
          bgcolor: "transparent",
        }}
      >
        <animated.div
          id="nav-bar"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            padding: state.auth.isMobile
              ? "30px 25px 30px 25px"
              : "10px 25px 10px 25px",
            width: "100%",
            backdropFilter: "blur(15px)",
            backgroundColor: "white",
            borderBottom: "1px solid #666",
            ...navContainer,
          }}
        >
          <Link
            style={{
              textDecoration: "none",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
            to={"/"}
          >
            <img
              src={require("../img/footor-logo.png")}
              style={{ height: "150px", position: "absolute", top: -25 }}
            />
          </Link>
          <div>
            {state.auth.isMobile ? (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerOpen}
                sx={{ color: "black", ...(open && { display: "none" }) }}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <div
                style={{
                  display: "flex",
                }}
              >
                <div style={{ display: "flex" }}>
                  <div>
                    <div
                      style={{ width: "150px", marginLeft: "-5px" }}
                      className="nav-item"
                      onMouseEnter={() => {
                        setActiveMenu(3);
                        menuContainerApi.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });

                        menuContainerApi4.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });
                      }}
                      onMouseLeave={() => {
                        setActiveMenu(10);
                      }}
                      onClick={() => {
                        navigate("/about");
                      }}
                    >
                      About Us
                    </div>
                    <animated.div
                      key={1}
                      className="nav-underline"
                      style={menuUnderlines[3]}
                    />
                  </div>
                  <div>
                    <div
                      style={{ width: "150px" }}
                      className="nav-item"
                      onClick={() => {
                        navigate("/services");
                      }}
                      onMouseEnter={() => {
                        setActiveMenu(1);
                        menuContainerApi.start({
                          from: { opacity: 0, display: "none" },
                          to: { opacity: 1, display: "block" },
                        });

                        menuContainerApi4.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });
                      }}
                      onMouseLeave={() => {
                        setActiveMenu(10);
                      }}
                    >
                      Services
                      <KeyboardArrowDownIcon
                        className="nav-icon"
                        style={{
                          fontSize: 20,
                          marginLeft: "5px",
                        }}
                      />
                    </div>
                    <animated.div
                      key={1}
                      className="nav-underline"
                      style={menuUnderlines[1]}
                    />
                  </div>
                  <div>
                    <div
                      style={{ width: "150px", marginLeft: "-10px" }}
                      className="nav-item"
                      onMouseEnter={() => {
                        setActiveMenu(2);
                        menuContainerApi.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });

                        menuContainerApi4.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });
                      }}
                      onMouseLeave={() => {
                        setActiveMenu(10);
                      }}
                      onClick={() => {
                        navigate("/why_us");
                      }}
                    >
                      Why Us
                    </div>
                    <animated.div
                      key={1}
                      className="nav-underline"
                      style={menuUnderlines[2]}
                    />
                  </div>

                  <div>
                    <div
                      style={{ width: "150px", marginLeft: "-5px" }}
                      className="nav-item"
                      onMouseEnter={() => {
                        setActiveMenu(4);
                        menuContainerApi.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });

                        menuContainerApi4.start({
                          from: { opacity: 0, display: "none" },
                          to: { opacity: 1, display: "block" },
                        });
                      }}
                      onMouseLeave={() => {
                        setActiveMenu(10);
                      }}
                      onClick={() => {
                        navigate("/industries");
                      }}
                    >
                      Industries
                    </div>
                    <animated.div
                      key={1}
                      className="nav-underline"
                      style={menuUnderlines[4]}
                    />
                  </div>
                  <div>
                    <div
                      style={{ width: "150px", marginLeft: "-10px" }}
                      className="nav-item"
                      onMouseEnter={() => {
                        setActiveMenu(5);
                        menuContainerApi.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });

                        menuContainerApi4.start({
                          from: { opacity: 1, display: "block" },
                          to: { opacity: 0, display: "none" },
                        });
                      }}
                      onMouseLeave={() => {
                        setActiveMenu(10);
                      }}
                      onClick={() => {
                        navigate("/careers");
                      }}
                    >
                      Careers
                    </div>
                    <animated.div
                      key={1}
                      className="nav-underline"
                      style={menuUnderlines[5]}
                    />
                  </div>
                </div>
                <div>
                  <div
                    style={{ width: "150px", marginLeft: "-10px" }}
                    className="nav-item"
                    onMouseEnter={() => {
                      setActiveMenu(6);
                      menuContainerApi.start({
                        from: { opacity: 1, display: "block" },
                        to: { opacity: 0, display: "none" },
                      });

                      menuContainerApi4.start({
                        from: { opacity: 1, display: "block" },
                        to: { opacity: 0, display: "none" },
                      });
                    }}
                    onMouseLeave={() => {
                      setActiveMenu(10);
                    }}
                    onClick={() => {
                      navigate("/contact");
                    }}
                  >
                    Contact Us
                  </div>
                  <animated.div
                    key={1}
                    className="nav-underline"
                    style={menuUnderlines[6]}
                  />
                </div>
              </div>
            )}
          </div>

          {/* <animated.div
            onMouseLeave={() => {
              menuContainerApi.start({
                from: { opacity: 1, display: "block" },
                to: { opacity: 0 },
              });
              setTimeout(
                () =>
                  menuContainerApi.start({
                    from: { opacity: 0, display: "block" },
                    to: { opacity: 0, display: "none" },
                  }),
                500
              );
            }}
            style={{ ...menuContainer }}
            id="menu-container"
            className="menu-open-container"
          >
            <div
              style={{
                textAlign: "left",
                marginTop: "10px",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "16px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginBottom: "10px",
              }}
            >
              AI and ML
            </div>
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <CardHorizontal
                navigate={"ai_ml"}
                title={"Artificial Intelligence"}
                subtitle={"Unleash cloud potential"}
                content={
                  <AdsClickIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"ai_ml"}
                title={"Blockchain"}
                subtitle={"Unleash cloud potential"}
                content={
                  <AdsClickIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"ai_ml"}
                title={"Machine Learning"}
                subtitle={"Protecting the Digital frontier"}
                content={
                  <AutoAwesomeIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
            <div
              style={{
                textAlign: "left",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "16px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginBottom: "10px",
              }}
            >
              Web design
            </div>
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <CardHorizontal
                navigate={"data_analytics"}
                title={"Wordpress Websites Design"}
                subtitle={"Innovate with Intelligence"}
                content={
                  <AppsIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"data_analytics"}
                title={"React JS Websites"}
                subtitle={"Securing tomorrow's transactions"}
                content={
                  <HomeIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"data_analytics"}
                title={"Website Maintenance"}
                subtitle={"Unleash cloud potential"}
                content={
                  <AdsClickIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
            <div
              style={{
                textAlign: "left",
                marginTop: "10px",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "16px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginBottom: "10px",
              }}
            >
              Mobile App design
            </div>
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <CardHorizontal
                navigate={"mobileapp"}
                title={"Cross Platform Hybrid Apps"}
                subtitle={"Future proof your business"}
                content={
                  <MenuOpenIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"mobileapp"}
                title={"Playstore/Appstore Deployment"}
                subtitle={"Innovate with Intelligence"}
                content={
                  <AppsIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"mobileapp"}
                title={"Integration Testing"}
                subtitle={"Continuous Integration"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>

            <div
              style={{
                textAlign: "left",
                marginTop: "10px",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "16px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginBottom: "10px",
              }}
            >
              Software Development
            </div>
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <CardHorizontal
                navigate={"software"}
                title={"Custom Software Development"}
                subtitle={"Future proof your business"}
                content={
                  <MenuOpenIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"software"}
                title={"MVP Development"}
                subtitle={"Innovate with Intelligence"}
                content={
                  <AppsIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"software"}
                title={"Software Maintenance"}
                subtitle={"Continuous Integration"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
            <div
              style={{
                textAlign: "left",
                marginTop: "10px",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "16px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginBottom: "10px",
              }}
            >
              UI/UX Design
            </div>
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <CardHorizontal
                navigate={"uiux"}
                title={"UI Design"}
                subtitle={"Future proof your business"}
                content={
                  <MenuOpenIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"uiux"}
                title={"UX Design"}
                subtitle={"Innovate with Intelligence"}
                content={
                  <AppsIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <SpacerH width="50px" />
              <CardHorizontal
                navigate={"uiux"}
                title={"Prototyping"}
                subtitle={"Continuous Integration"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
          </animated.div> */}

          <animated.div
            onMouseLeave={() => {
              menuContainerApi.start({
                from: { opacity: 1, display: "block" },
                to: { opacity: 0 },
              });
              setTimeout(
                () =>
                  menuContainerApi.start({
                    from: { opacity: 0, display: "block" },
                    to: { opacity: 0, display: "none" },
                  }),
                500
              );
            }}
            style={{ ...menuContainer }}
            id="menu-container"
            className="menu-open-container"
          >
            <div
              style={{
                textAlign: "left",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "22px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginTop: "15px",
              }}
            >
              IT Services
            </div>
            <div style={{ display: "flex" }}>
              <CardHorizontal
                navigate={"ai_ml"}
                title={"AI and ML"}
                subtitle={"Short-term jobs to try roles"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"kubernetes"}
                title={"Kubernetes Services"}
                subtitle={"Container Apps"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"cloud"}
                title={"Cloud Services"}
                subtitle={"Cloud based Applications"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
            <div style={{ display: "flex" }}>
              <CardHorizontal
                navigate={"devops"}
                title={"DevOps"}
                subtitle={"DevOps Services"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"mobile"}
                title={"Mobile App Development"}
                subtitle={"Onsite, Remote or Hybrid staff"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"data_analytics"}
                title={"Data Analytics"}
                subtitle={"Your Digital Front"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
            <div style={{ display: "flex" }}>
              <CardHorizontal
                navigate={"software"}
                title={"Software Development"}
                subtitle={"Full-time hiring"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"managed_it"}
                title={"Managed IT Services"}
                subtitle={"Total Workforce solution"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"uiux"}
                title={"UI/UX Design"}
                subtitle={"Contract for specific time"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
            <div
              style={{
                textAlign: "left",
                marginTop: "0px",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "22px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginTop: "15px",
              }}
            >
              Staff Augmentation
            </div>
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <CardHorizontal
                navigate={"staff_augmentation"}
                title={"Skillset Based"}
                subtitle={"IT, Creative, Engineering, etc"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"staff_augmentation"}
                title={"Timeframe Based"}
                subtitle={"Short term, Long term, Project based"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"staff_augmentation"}
                title={"Based on Expertise"}
                subtitle={"Entry-Level Staff, Mid Level, Senior Experts"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
            </div>
            <div
              style={{
                textAlign: "left",
                marginTop: "0px",
                marginLeft: "15px",
                borderRadius: "25px",
                fontSize: "22px",
                color: themeStyle.primaryColor,
                fontWeight: 600,
                marginTop: "15px",
              }}
            >
              Staffing Solutions
            </div>
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <CardHorizontal
                navigate={"permanent_hiring"}
                title={"Permanent Hiring"}
                subtitle={"IT, Creative, Engineering, etc"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
              <CardHorizontal
                navigate={"contract_hiring"}
                title={"Contract Hiring"}
                subtitle={"Short term, Long term, Project based"}
                content={
                  <DeblurIcon
                    style={{ fontSize: "30px", color: themeStyle.primaryColor }}
                  />
                }
              />
             
            </div>
          </animated.div>
        </animated.div>
      </AppBar>

      {state.auth.isMobile ? (
        <Drawer variant="temporary" anchor="left" open={open}>
          <DrawerHeader
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "75vw",
            }}
          >
            <Link
              style={{
                marginTop: "25px",
                textDecoration: "none",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryButtonTextColor
                    : themeStyle.primaryButtonTextColor,
              }}
              to={"/"}
            >
              <img
                src={require("../img/footor-logo.png")}
                style={{ height: "100px" }}
              />
            </Link>
            <IconButton onClick={handleDrawerClose}>
              <CloseIcon />
            </IconButton>
          </DrawerHeader>
          <List>
            <Select
              sx={{
                marginTop: "25px",
                padding: "0px",
                height: "20px",
                color: "black",
                fontSize: state.auth.isMobile ? "20px" : "25px",
                borderRadius: "50px",
                borderColor: "blue",
                fontFamily: "Montserrat",
                "& .MuiSvgIcon-root": {
                  color: "black",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&:hover": {
                  "&& fieldset": {
                    backgroundColor: "transparent",
                  },
                },
              }}
              value={"Services"}
            >
              <MenuItem
                className="nav-menu-item"
                value="Services"
                onClick={() => {
                  navigate("/services");
                }}
                style={{
                  fontFamily: "Montserrat",
                  display: "none",
                }}
              >
                Services
              </MenuItem>

              <MenuItem
                className="nav-menu-item"
                value="/services"
                style={{ fontFamily: "Montserrat", fontWeight: "600" }}
              >
                <Select
                  sx={{
                    padding: "0px",
                    height: "20px",
                    color: "black",
                    fontSize: state.auth.isMobile ? "20px" : "25px",
                    borderRadius: "50px",
                    borderColor: "blue",
                    fontFamily: "Montserrat",
                    "& .MuiSvgIcon-root": {
                      color: "black",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover": {
                      "&& fieldset": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                  value={"IT Services"}
                >
                  <MenuItem
                    disabled
                    value="IT Services"
                    style={{
                      fontFamily: "Montserrat",
                      display: "none",
                    }}
                  >
                    IT Services
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/ai_ml"
                    onClick={() => {
                      navigate("/ai_ml");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    AI and ML
                  </MenuItem>
                  <MenuItem
                    className="nav-menu-item"
                    value="/kubernetes"
                    onClick={() => {
                      navigate("/kubernetes");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Kubernetes Services
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/cloud"
                    onClick={() => {
                      navigate("/cloud");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Cloud Services
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/managed_it"
                    onClick={() => {
                      navigate("/managed_it");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Managed IT Services
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/mobile"
                    onClick={() => {
                      navigate("/mobile");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Mobile App Development
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/data_analytics"
                    onClick={() => {
                      navigate("/data_analytics");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Data Analytics
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/software"
                    onClick={() => {
                      navigate("/software");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Software Development
                  </MenuItem>
                  <MenuItem
                    className="nav-menu-item"
                    value="/uiux"
                    onClick={() => {
                      navigate("/uiux");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    UI/UX Design
                  </MenuItem>
                </Select>
              </MenuItem>
              <MenuItem
                className="nav-menu-item"
                value="/services"
                style={{ fontFamily: "Montserrat", fontWeight: "600" }}
              >
                <Select
                  sx={{
                    padding: "0px",
                    height: "20px",
                    color: "black",
                    fontSize: state.auth.isMobile ? "20px" : "25px",
                    borderRadius: "50px",
                    borderColor: "blue",
                    fontFamily: "Montserrat",
                    "& .MuiSvgIcon-root": {
                      color: "black",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover": {
                      "&& fieldset": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                  value={"Staff Augmentation"}
                >
                  <MenuItem
                    disabled
                    value="Staff Augmentation"
                    style={{
                      fontFamily: "Montserrat",
                      display: "none",
                    }}
                  >
                    Staff Augmentation
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/services"
                    onClick={() => {
                      navigate("/services");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Skillset Based
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/services"
                    onClick={() => {
                      navigate("/services");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Timeframe Based
                  </MenuItem>

                  <MenuItem
                    className="nav-menu-item"
                    value="/services"
                    onClick={() => {
                      navigate("/services");
                    }}
                    style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                  >
                    Based on Expertise
                  </MenuItem>
                </Select>
              </MenuItem>
            </Select>

            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            <div
              onClick={() => {
                navigate("/about");
              }}
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
              }}
            >
              About Us
            </div>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            <div
              onClick={() => {
                navigate("/why_us");
              }}
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
              }}
            >
              <Select
                sx={{
                  padding: "0px",
                  height: "20px",
                  color: "black",
                  fontSize: state.auth.isMobile ? "20px" : "25px",
                  borderRadius: "50px",
                  borderColor: "blue",
                  fontFamily: "Montserrat",
                  "& .MuiSvgIcon-root": {
                    color: "black",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&:hover": {
                    "&& fieldset": {
                      backgroundColor: "transparent",
                    },
                  },
                }}
                value={"Why Us"}
                onChange={(e) => {
                  navigate(e.target.value);
                }}
              >
                <MenuItem
                  disabled
                  value="Why Us"
                  onClick={() => {
                    navigate("/why_us");
                  }}
                  style={{
                    fontFamily: "Montserrat",
                    display: "none",
                  }}
                >
                  Why Us
                </MenuItem>

                <MenuItem
                  className="nav-menu-item"
                  value="/why_us"
                  onClick={() => {
                    navigate("/why_us");
                  }}
                  style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                >
                  Domain Experinced Team
                </MenuItem>

                <MenuItem
                  className="nav-menu-item"
                  value="/why_us"
                  onClick={() => {
                    navigate("/why_us");
                  }}
                  style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                >
                  Tailor made recruitment solutions
                </MenuItem>

                <MenuItem
                  className="nav-menu-item"
                  value="/why_us"
                  onClick={() => {
                    navigate("/why_us");
                  }}
                  style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                >
                  Comprehensive screening
                </MenuItem>

                <MenuItem
                  className="nav-menu-item"
                  value="/why_us"
                  onClick={() => {
                    navigate("/why_us");
                  }}
                  style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                >
                  Quick response
                </MenuItem>

                <MenuItem
                  className="nav-menu-item"
                  value="/why_us"
                  onClick={() => {
                    navigate("/why_us");
                  }}
                  style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                >
                  Ongoing Support
                </MenuItem>

                <MenuItem
                  className="nav-menu-item"
                  value="/why_us"
                  onClick={() => {
                    navigate("/why_us");
                  }}
                  style={{ fontFamily: "Montserrat", fontWeight: "600" }}
                >
                  Exlusive access
                </MenuItem>
              </Select>
            </div>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            <div
              onClick={() => {
                navigate("/industries");
              }}
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
              }}
            >
              Industries
            </div>
            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            <div
              onClick={() => {
                navigate("/careers");
              }}
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
              }}
            >
              Careers at CGT Solutions
            </div>

            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            <div
              onClick={() => {
                navigate("/contact");
              }}
              style={{
                width: "100%",
                fontSize: 20,
                padding: "5px",
                paddingLeft: "15px",
              }}
            >
              Contact Us
            </div>

            <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
          </List>
        </Drawer>
      ) : (
        <Fragment></Fragment>
      )}
    </Box>
  );
}

export default Sidebar;
